import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import { AdGroup } from '../../types/active-directory'
const { ACTIVE_DIRECTORY_API_URL } = CONSTANT

export default async function getAllAdGroups(): Promise<AdGroup[]> {
	const response = await fetchWithAuthorizationHeader(`${ACTIVE_DIRECTORY_API_URL}`)
	const payload = await response.json().catch(() => null)

	if (!response.ok) {
		const message =
			(typeof payload?.detail === 'string' && payload.detail) ||
			(typeof payload?.error === 'string' && payload.error) ||
			'Failed to fetch Active Directory groups'

		throw new Error(message)
	}

	if (!Array.isArray(payload)) {
		throw new Error('Invalid Active Directory groups response')
	}

	return payload
}
